export default "__VITE_ASSET__CQV5a0xd__"